import React from "react";
import { FaMedal, FaUsers } from "react-icons/fa";
import { GiShuttlecock } from "react-icons/gi";

const activities = [
  {
    title: "NCC 'C' Certificate",
    description:
      "Awarded the prestigious NCC C Certificate in 3(A) Naval Unit, Visakhapatnam during 2020-2023. This reflects my dedication, discipline, and leadership skills.",
    icon: <FaMedal />,
    timeline: "2020 - 2023",
  },
  {
    title: "Sports Club Secretary",
    description:
      "Served as the Sports Club Secretary for the IT Department at Anil Neerukonda Institute of Technology and Sciences. Organized events and fostered a vibrant sports culture.",
    icon: <FaUsers />,
    timeline: "2023 - 2024",
  },
  {
    title: "Badminton",
    description:
      "Passionate about badminton, often participating in the practice sessions and enjoying the thrill of the game.",
    icon: <GiShuttlecock />,
    timeline: "",
  },
];

export default function Extracurricular() {
  return (
    <div className="overflow-hidden">
      <div
        className="relative w-full min-h-screen"
        style={{
          backgroundImage:
            "linear-gradient(135deg, rgba(18, 16, 13, 0.92) 0%, rgba(32, 26, 19, 0.92) 50%, rgba(14, 12, 10, 0.94) 100%), url('/assets/school.webp')",
          backgroundAttachment: "fixed",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Subtle Background Pattern */}
        <div className="absolute inset-0 opacity-[0.04]">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `radial-gradient(circle at 25% 25%, #c9a876 1px, transparent 1px),
                             radial-gradient(circle at 75% 75%, #c9a876 1px, transparent 1px)`,
              backgroundSize: "60px 60px",
            }}
          ></div>
        </div>

        {/* Mystical Floating Elements — softened, no blinking */}
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-20 left-10 w-1 h-1 bg-[#c9a876] rounded-full"></div>
          <div className="absolute top-40 right-20 w-0.5 h-0.5 bg-[#e8dcc4] rounded-full"></div>
          <div className="absolute bottom-40 left-1/4 w-1 h-1 bg-[#c9a876] rounded-full"></div>
          <div className="absolute top-60 right-1/3 w-0.5 h-0.5 bg-[#e8dcc4] rounded-full"></div>
          <div className="absolute top-80 left-1/3 w-1 h-1 bg-[#c9a876] rounded-full"></div>
          <div className="absolute bottom-60 right-1/4 w-0.5 h-0.5 bg-[#e8dcc4] rounded-full"></div>
        </div>

        {/* Page Header */}
        <div className="relative py-16 md:py-24 text-center">
          {/* Decorative Line */}
          <div className="flex items-center justify-center space-x-4 mb-8 md:mb-12">
            <div className="w-8 md:w-12 h-px bg-[#c9a876]"></div>
            <div className="w-2 h-2 border border-[#c9a876] rotate-45"></div>
            <div className="w-12 h-px bg-[#c9a876]"></div>
          </div>

          <h1 className="hero-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light text-[#f5f0e6] leading-none tracking-wide mb-6 md:mb-8">
            Extracurricular
          </h1>

          <div className="flex items-center justify-center space-x-4 md:space-x-6 mb-6 md:mb-8">
            <div className="w-12 md:w-16 h-px bg-[#e8dcc4] opacity-40"></div>
            <h2 className="hero-body text-xl sm:text-2xl md:text-3xl font-light text-[#c9a876] tracking-[0.3em] uppercase">
              Activities
            </h2>
          </div>

          <p className="hero-body text-base sm:text-lg md:text-xl text-[#a89a86] max-w-2xl mx-auto leading-relaxed px-6">
            Beyond academics—my achievements and passions that shape my
            well-rounded personality.
          </p>

          {/* Decorative Bottom Element */}
          <div className="flex items-center justify-center space-x-3 mt-8 md:mt-12">
            <div className="w-6 md:w-8 h-px bg-[#c9a876]"></div>
            <div className="w-1 h-1 bg-[#c9a876] rounded-full"></div>
            <div className="w-3 md:w-4 h-px bg-[#c9a876]"></div>
            <div className="w-1 h-1 bg-[#c9a876] rounded-full"></div>
          </div>
        </div>

        {/* Activities Section */}
        <div className="relative px-4 sm:px-8 md:px-12 lg:px-20 pb-16 md:pb-24">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
            {activities.map((activity, index) => (
              <div
                key={index}
                className="group relative overflow-hidden transition-all duration-500 hover:scale-105"
              >
                {/* Card Container */}
                <div className="relative bg-black/20 backdrop-blur-sm overflow-hidden border border-[#c9a876]/20 hover:border-[#c9a876]/40 transition-all duration-300 h-full">
                  {/* Activity Icon Section */}
                  <div className="relative p-8 text-center border-b border-[#c9a876]/20">
                    <div className="text-5xl md:text-6xl text-[#c9a876] mb-4 group-hover:text-white transition-colors duration-300">
                      {activity.icon}
                    </div>

                    {/* Timeline Badge */}
                    <div className="hero-body inline-block px-4 py-2 bg-[#c9a876]/10 border border-[#c9a876]/30 text-[#c9a876] text-sm tracking-wider">
                      {activity.timeline}
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="relative p-6 md:p-8 bg-gradient-to-b from-black/40 to-black/60 flex-1">
                    {/* Title with decorative line */}
                    <div className="flex items-center space-x-3 mb-4 md:mb-6">
                      <div className="w-6 h-px bg-[#c9a876]"></div>
                      <h2 className="hero-display text-xl md:text-2xl font-light text-[#f5f0e6] tracking-wide">
                        {activity.title}
                      </h2>
                    </div>

                    <p className="hero-body text-gray-300 leading-relaxed font-light text-sm md:text-base">
                      {activity.description}
                    </p>

                    {/* Bottom decorative element */}
                    <div className="flex items-center space-x-2 mt-6">
                      <div className="w-8 h-px bg-[#e8dcc4] opacity-30"></div>
                      <div className="w-1 h-1 bg-[#c9a876] rounded-full"></div>
                      <div className="w-4 h-px bg-[#e8dcc4] opacity-30"></div>
                    </div>
                  </div>

                  {/* Decorative Corner Elements */}
                  <div className="absolute -top-2 -left-2 w-4 h-4 border-l-2 border-t-2 border-[#c9a876] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute -top-2 -right-2 w-4 h-4 border-r-2 border-t-2 border-[#c9a876] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute -bottom-2 -left-2 w-4 h-4 border-l-2 border-b-2 border-[#c9a876] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute -bottom-2 -right-2 w-4 h-4 border-r-2 border-b-2 border-[#c9a876] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Section Divider */}
        <div className="relative py-16 text-center">
          <div className="flex items-center justify-center space-x-4">
            <div className="w-20 h-px bg-[#c9a876]"></div>
            <div className="w-2 h-2 bg-[#c9a876] rounded-full"></div>
            <div className="w-8 h-px bg-[#e8dcc4] opacity-40"></div>
            <div className="w-2 h-2 bg-[#c9a876] rounded-full"></div>
            <div className="w-20 h-px bg-[#c9a876]"></div>
          </div>
        </div>

        {/* Bottom Fade */}
        <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-black/20 to-transparent"></div>
      </div>
    </div>
  );
}
